import { render } from "./HeroBanner.vue?vue&type=template&id=2c724eaa&scoped=true"
import script from "./HeroBanner.vue?vue&type=script&lang=js"
export * from "./HeroBanner.vue?vue&type=script&lang=js"

import "./HeroBanner.vue?vue&type=style&index=0&id=2c724eaa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c724eaa"]])

export default __exports__